/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What happens after the date passes?`)
};

const es_cd_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué pasa cuando la fecha ya ha pasado?`)
};

const de_cd_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was passiert, nachdem das Datum vergangen ist?`)
};

const nl_cd_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat gebeurt er nadat de datum is verstreken?`)
};

const fr_cd_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que se passe-t-il après le passage de la date ?`)
};

const it_cd_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa succede dopo che la data è passata?`)
};

const pt_br2_cd_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que acontece depois que a data passa?`)
};

const pt_cd_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que acontece depois de a data passar?`)
};

const ja_cd_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付を過ぎるとどうなりますか?`)
};

const zh_cd_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期过后会发生什么？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_faq_q2", locale)
	if (locale === "en") return en_cd_faq_q2(inputs)
	if (locale === "es") return es_cd_faq_q2(inputs)
	if (locale === "de") return de_cd_faq_q2(inputs)
	if (locale === "nl") return nl_cd_faq_q2(inputs)
	if (locale === "fr") return fr_cd_faq_q2(inputs)
	if (locale === "it") return it_cd_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_cd_faq_q2(inputs)
	if (locale === "pt") return pt_cd_faq_q2(inputs)
	if (locale === "ja") return ja_cd_faq_q2(inputs)
	return zh_cd_faq_q2(inputs)
};